import axios from 'axios';
import { Notify } from 'quasar'

export function downloadBulletinInfos(userName, password)
{
  return new Promise((resolve) =>
  {
    axios(
    {
        method: 'get',
        url: 'https://zwszwqztccs.top/serverGeneral/downloadBulletinInfos',

        params:
        {
            userName: userName,
            password: password,
        },
    })
    .then((response) =>
    {
        if (response.status === 200)
        {
            if (response.data === '账号或密码错误！')
            {
                Notify.create(
                {
                    position: 'top',
                    icon: 'report_problem',
                    color: 'negative',
                    message: '账号或密码错误！',
                })
            }
            else
            {
              resolve(response.data)
            }
        }
        else
        {
            Notify.create(
            {
                position: 'center',
                icon: 'report_problem',
                color: 'negative',
                message: '服务器返回失败。'
            })
        }
    })
    .catch(() =>
    {
        Notify.create(
        {
            position: 'center',
            icon: 'report_problem',
            color: 'negative',
            message: '连接失败！'
        })
    })
  });
}
